window.customFormConfigFactory = (function () {

    let conditionalCheckers = {
        OtherPropertyBoolean : function(conditional,form){
            let otherElementIsTrue = form && !!form[conditional.otherProperty];
            if(conditional.inverse){
                return !otherElementIsTrue;
            }
            return otherElementIsTrue
        }
    }

    function addVisibilities(customFormDefinition){
        customFormDefinition.elements.forEach(el=>addVisibility(el));
        customFormDefinition.popupElements.forEach(el=>addVisibility(el));
    }

    function addVisibility(elementConfig){
        if(!elementConfig.visibility){
            elementConfig.isVisibile = () => true;
            return;
        }

        elementConfig.isVisibile = function(form){
            return elementConfig.visibility.every((conditional) => conditionalCheckers[conditional.type](conditional,form));
        }
    }

    return {
        create: function (beschikbaarheidTypes) {
            let customForms = {};
             beschikbaarheidTypes.forEach(function (type) {
                 if(type.customFormDefinition) {
                     addVisibilities(type.customFormDefinition)
                 }
                customForms[type.id] = type.customFormDefinition;
            });
            return customForms;
        }
    };
})();
